import UsersProfileContainer from "../../../components/applications/users/usersProfile";

const UsersProfile = () => {
  return <UsersProfileContainer />;
};

export default UsersProfile;
